<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlidePoi$ | async; as poi) {
  <!-- Images -->
  @if (slideAuthorFacade.imageIdsByPoi$(poi.id) | async; as imageIds) {
    <medsurf-design-input-multi-select
      [name]="'poi_images'"
      [label]="'global.images'"
      [model]="imageIds"
      [options]="(slideAuthorFacade.currentSelectedSlideImagesArray$(translate, imageIds) | async) || []"
      [optionDisabled]="'inactive'"
      [showToggleAll]="true"
      [group]="true"
      [class]="'w-full'"
      [labelIcon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
    (valueChange)="onChange($event)"></medsurf-design-input-multi-select>
  }
}
